export const useStyles = () => {
    return {
        tabs: {
            width: 'fit-content'
        },
        tabList: ({ isTracking }: { isTracking: boolean }) => (
            {
                justifyContent: isTracking ? 'end' : 'space-between',
                '& .MuiTabs-scroller': {
                    width: 'fit-content',
                },
            }
        ),
        tabContainer: {
            '& .MuiTabPanel-root': {
                height: 'calc(100% - 12px)',
            }
        },
        header: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        }
    }
}